module.exports = __webpack_public_path__ + "img/burger.b101f6e8.svg";